import { sendRequest } from "../../../util/httpClient";
import { months } from "../../../util/CommonLists";

const isObjectNotNull = (val: any) => val && Object.keys(val).length > 0;

const updateMonitoringInfo = async (personalInfo: any, addressInfo: any, ssn?: string, formData?: any, isPrimaryAccount?: boolean, isIDFUser?: boolean) => {
    const IsChildUser: boolean = isPrimaryAccount ? false : true;
    const isEZSChildUser: boolean = IsChildUser && !isIDFUser;

    personalInfo.phone =
        personalInfo.phone &&
        personalInfo.phone.map((phone: any) => {
            phone.phone = phone.phone.replace(/[^0-9+]/g, "");
            return phone;
        });

    let phone: any, email: any, sin: any, nid: any;
    if (formData && formData.phone) {
        phone =
            personalInfo.phone && personalInfo.phone.length > 0
            ? personalInfo.phone.map((phone: any, index: number) => {
                const pId = formData.phone.filter((elem: any) => elem.phone);
                      if (pId[index] !== undefined && pId.findIndex((element: any) => element.phone === phone.phone) >= 0) {
                          const newPhone = pId[pId.findIndex((element: any) => element.phone === phone.phone)];
                          newPhone["action"] = "UPDATE";
                          return newPhone;
                      } else {
                          phone["action"] = "ADD";
                          return phone;
                      }
                  })
                : [{}];
        email =
            personalInfo.emails && personalInfo.emails.length > 0
                ? personalInfo.emails.map((email: any, index: number) => {
                      const eId = formData.emails.filter((elem: any) => elem.email);
                      if (eId[index] !== undefined && eId.findIndex((element: any) => element.email === email.email) >= 0) {
                          const newEmail = eId[eId.findIndex((element: any) => element.email === email.email)];
                          newEmail["action"] = "UPDATE";
                          return newEmail;
                      } else {
                          email["action"] = "ADD";
                          return email;
                      }
                  })
            : [{}];
        if (isIDFUser) {
            const deletedEmails = personalInfo.emails && personalInfo.emails.length > 0 && formData.emails.filter((data: any) => !personalInfo.emails.find((pData: any) => pData.email === data.email));
            if (deletedEmails && deletedEmails.length) {
                deletedEmails.forEach((dEmail: any) => {
                    dEmail["action"] = "DELETE";
                    email.push(dEmail);
                });
            }
        }
    }

    let primaryMail;
    if (isPrimaryAccount === false && !isEZSChildUser) {
        primaryMail = [{}];
    } else {
        primaryMail = email !== undefined ? email.splice(0, 1) : personalInfo["primary-email-address"] ? [personalInfo["primary-email-address"]] : [{}];
        primaryMail[0]["action"] = "UPDATE";
    }

    const primaryPhone = phone !== undefined ? phone.splice(0, 1) : personalInfo["primary-phone"] ? [personalInfo["primary-phone"]] : [{}];
    primaryPhone[0]["action"] = "UPDATE";

    if (personalInfo.internationalSecurityNumber) {
        if (formData.internationalSecurityNumber && !formData.internationalSecurityNumber.sin) {
            sin = {
                action: "ADD",
                "monitor-id": "",
                "record-id": "",
                sin: personalInfo.internationalSecurityNumber,
            };
        }
    }
    if (personalInfo.nationalIdentificationNumber) {
        if (formData.nationalIdentificationNumber && !formData.nationalIdentificationNumber.nid) {
            nid = {
                action: "ADD",
                "monitor-id": "",
                "record-id": "",
                nid: personalInfo.nationalIdentificationNumber,
            };
        }
    }
    const requestBody = {
        IsChildUser: IsChildUser,
        asset: {
            personalInformation: {
                "first-name": personalInfo["first-name"] ? personalInfo["first-name"] : personalInfo.firstName,
                "last-name": personalInfo["last-name"] ? personalInfo["last-name"] : personalInfo.lastName,
                "primary-email-address": isPrimaryAccount || isEZSChildUser ? primaryMail[0] : null,
                "primary-phone": primaryPhone[0],
                "additional-emails-address": email
                    ? email
                    : personalInfo["additional-emails-address"]
                    ? personalInfo["additional-emails-address"].map((email: any) => {
                          email["action"] = "UPDATE";
                          return email;
                      })
                    : personalInfo.emails,
                "additional-phone": phone
                    ? phone
                    : personalInfo["additional-phone"]
                    ? personalInfo["additional-phone"].map((phone: any) => {
                          phone["action"] = "UPDATE";
                          return phone;
                      })
                    : personalInfo.phone,
                "date-of-birth": formData
                    ? formData["date-of-birth"]
                        ? formData["date-of-birth"]
                        : `${
                              months.indexOf(personalInfo.birthMonth) + 1 < 10
                                  ? "0" + (months.indexOf(personalInfo.birthMonth) + 1)
                                  : months.indexOf(personalInfo.birthMonth) + 1
                          }/${personalInfo.birthDay < 10 ? "0" + personalInfo.birthDay : personalInfo.birthDay}/${personalInfo.birthYear}`
                    : personalInfo["date-of-birth"],
                ssn: ssn && formData["securityNumber"] ? null : ssn,
                "monitoring-sin": sin,
                "monitoring-nid": nid,
            },
            addressInformation: {
                "address-street": addressInfo["address-street"] ? addressInfo["address-street"] : addressInfo["address1"],
                "address-street2": addressInfo["urbanization"] 
                ? addressInfo["address-street2"] 
                 ? addressInfo["address-street2"] + ';' + addressInfo["urbanization"] 
                 : addressInfo["address2"] + ';' + addressInfo["urbanization"]
                 : addressInfo["address-street2"] ? addressInfo["address-street2"] 
                 : addressInfo["address2"],
                "address-street3": addressInfo["address-street3"] ? addressInfo["address-street3"] : addressInfo["address3"],
                "address-city": addressInfo["address-city"] ? addressInfo["address-city"] : addressInfo["city"],
                "address-state": addressInfo["address-state"] ? addressInfo["address-state"] : addressInfo["state"],
                "address-country": addressInfo.country ? addressInfo.country : null,
                "address-code": addressInfo["address-code"] ? addressInfo["address-code"] : addressInfo["zipcode"],
                action: "UPDATE",
            },
        },
        "ezshield-id": formData && formData["ezshield-id"],
    };
    return sendRequest("post", `api/secureMonitoring/manageMonitoredAssets`, requestBody);
};

const updateBusinessMonitoringInfo = async (personalInfo: any, addressInfo: any, formData?: any) => {
    personalInfo.phone =
        personalInfo.phone &&
        personalInfo.phone.map((phone: any) => {
            phone.phone = phone.phone.replace(/[^0-9+]/g, "");
            return phone;
        });

    let phone: any, email: any, sin: any, nid: any;
    if (formData && formData.phone) {
        phone =
            personalInfo.phone && personalInfo.phone.length > 0
                ? personalInfo.phone.map((phone: any, index: number) => {
                      const pId = formData.phone.filter((elem: any) => elem.phone);
                      if (pId[index] !== undefined && pId.findIndex((element: any) => element.phone === phone.phone) >= 0) {
                          const newPhone = pId[pId.findIndex((element: any) => element.phone === phone.phone)];
                          newPhone["action"] = "UPDATE";
                          return newPhone;
                      } else {
                          phone["action"] = "ADD";
                          return phone;
                      }
                  })
                : [{}];
        email =
            personalInfo.emails && personalInfo.emails.length > 0
                ? personalInfo.emails.map((email: any, index: number) => {
                      const eId = formData.emails.filter((elem: any) => elem.email);
                      if (eId[index] !== undefined && eId.findIndex((element: any) => element.email === email.email) >= 0) {
                          const newEmail = eId[eId.findIndex((element: any) => element.email === email.email)];
                          newEmail["action"] = "UPDATE";
                          return newEmail;
                      } else {
                          email["action"] = "ADD";
                          return email;
                      }
                  })
                : [{}];
    }

    if (personalInfo.internationalSecurityNumber) {
        if (formData.internationalSecurityNumber && !formData.internationalSecurityNumber.sin) {
            sin = {
                action: "ADD",
                "monitor-id": "",
                "record-id": "",
                sin: personalInfo.internationalSecurityNumber,
            };
        }
    }
    if (personalInfo.nationalIdentificationNumber) {
        if (formData.nationalIdentificationNumber && !formData.nationalIdentificationNumber.nid) {
            nid = {
                action: "ADD",
                "monitor-id": "",
                "record-id": "",
                nid: personalInfo.nationalIdentificationNumber,
            };
        }
    }
    const primaryMail = email !== undefined ? email.splice(0, 1) : personalInfo["primary-email-address"] ? [personalInfo["primary-email-address"]] : [{}];
    primaryMail[0]["action"] = "UPDATE";

    const primaryPhone = phone !== undefined ? phone.splice(0, 1) : personalInfo["primary-phone"] ? [personalInfo["primary-phone"]] : [{}];
    primaryPhone[0]["action"] = "UPDATE";

    const requestBody = {
        asset: {
            personalInformation: {
                "first-name": personalInfo["first-name"] ? personalInfo["first-name"] : formData ? formData["firstName"] : "",
                "middle-name": personalInfo["middle-name"] ? personalInfo["middle-name"] : formData ? formData["middleName"] : "",
                "last-name": personalInfo["last-name"] ? personalInfo["last-name"] : formData ? formData["lastName"] : "",
                "primary-email-address": primaryMail[0],
                "primary-phone": primaryPhone[0],
                "additional-emails-address": email
                    ? email
                    : personalInfo["additional-emails-address"]
                    ? personalInfo["additional-emails-address"].map((email: any) => {
                          email["action"] = "UPDATE";
                          return email;
                      })
                    : personalInfo.emails,
                "additional-phone": phone
                    ? phone
                    : personalInfo["additional-phone"]
                    ? personalInfo["additional-phone"].map((phone: any) => {
                          phone["action"] = "UPDATE";
                          return phone;
                      })
                    : personalInfo.phone,
                "date-of-birth": null,
                ssn: "",
                "monitoring-sin": sin,
                "monitoring-nid": nid,
                "business-credit-safe-number": personalInfo["business-credit-safe-number"]
                    ? personalInfo["business-credit-safe-number"]
                    : personalInfo.businessCreditSafeNumber,
                "business-duns-number": personalInfo["business-duns-number"] ? personalInfo["business-duns-number"] : personalInfo.businessDUNSNumber,
                "business-ein-number": personalInfo["business-ein-number"] ? personalInfo["business-ein-number"] : personalInfo.businessEINNumber,
                "business-fax-number": personalInfo["business-fax-number"] ? personalInfo["business-fax-number"] : personalInfo.businessFaxNumber,
                "business-name": personalInfo["business-name"] ? personalInfo["business-name"] : personalInfo.businessName,
                "business-state-registry-number": personalInfo["business-state-registry-number"]
                    ? personalInfo["business-state-registry-number"]
                    : personalInfo.businessStateRegistryNumber,
                "company-domain": personalInfo["company-domain"] ? personalInfo["company-domain"] : personalInfo.companyDomain,
            },
            addressInformation: {
                "address-street": addressInfo["address-street"] ? addressInfo["address-street"] : addressInfo["address1"],
                "address-street2": addressInfo["address-street2"] ? addressInfo["address-street2"] : addressInfo["address2"],
                "address-street3": addressInfo["address-street3"] ? addressInfo["address-street3"] : addressInfo["address3"],
                "address-city": addressInfo["address-city"] ? addressInfo["address-city"] : addressInfo["city"],
                "address-state": addressInfo["address-state"] ? addressInfo["address-state"] : addressInfo["state"],
                "address-country": addressInfo.country ? addressInfo.country : null,
                "address-code": addressInfo["address-code"] ? addressInfo["address-code"] : addressInfo["zipcode"],
                action: "UPDATE",
            },
        },
        "ezshield-id": formData && formData["ezshield-id"],
    };
    return sendRequest("post", `api/secureMonitoring/manageMonitoredAssets`, requestBody);
};

const updateBusinessupdateAddtionalInfo = async (formData: any, addressInfo: any, personalInfo?: any) => {
    let primaryEmail: any, primaryPhone: any, additionalEmail: any, additionalPhone: any;
    if (personalInfo["primary-email-address"]) {
        primaryEmail = personalInfo["primary-email-address"];
        primaryEmail["action"] = "UPDATE";
    }

    if (personalInfo["primary-phone"]) {
        primaryPhone = personalInfo["primary-phone"];
        primaryPhone["action"] = "UPDATE";
    }

    if (personalInfo["additional-emails-address"]) {
        additionalEmail = personalInfo["additional-emails-address"].map((email: any) => {
            email["action"] = "UPDATE";
            return email;
        });
    }

    if (personalInfo["additional-phone"]) {
        additionalPhone = personalInfo["additional-phone"].map((phone: any) => {
            phone["action"] = "UPDATE";
            return phone;
        });
    }

    const requestBody = {
        asset: {
            personalInformation: {
                "first-name": personalInfo["first-name"] ? personalInfo["first-name"] : "",
                "middle-name": personalInfo["middle-name"] ? personalInfo["middle-name"] : "",
                "last-name": personalInfo["last-name"] ? personalInfo["last-name"] : "",
                "primary-email-address": primaryEmail ? primaryEmail : [{}],
                "primary-phone": primaryPhone ? primaryPhone : [{}],
                "additional-emails-address": additionalEmail ? additionalEmail : [],
                "additional-phone": additionalPhone ? additionalPhone : [],
                "date-of-birth": null,
                ssn: "",
                "monitoring-sin": personalInfo["monitoring-sin"] ? personalInfo["monitoring-sin"] : {},
                "monitoring-nid": personalInfo["monitoring-nid"] ? personalInfo["monitoring-nid"] : {},
                "business-credit-safe-number": personalInfo["business-credit-safe-number"]
                    ? personalInfo["business-credit-safe-number"]
                    : personalInfo.businessCreditSafeNumber,
                "business-duns-number": personalInfo["business-duns-number"] ? personalInfo["business-duns-number"] : personalInfo.businessDUNSNumber,
                "business-ein-number": personalInfo["business-ein-number"] ? personalInfo["business-ein-number"] : "",
                "business-fax-number": personalInfo["business-fax-number"] ? personalInfo["business-fax-number"] : "",
                "business-name": personalInfo["business-name"] ? personalInfo["business-name"] : "",
                "business-state-registry-number": formData.businessStateRegistryNumber ? formData.businessStateRegistryNumber : null,
                "company-domain": formData.companyDomain ? formData.companyDomain : null,
            },
            addressInformation: {
                "address-street": addressInfo["address-street"] ? addressInfo["address-street"] : addressInfo["address1"],
                "address-street2": addressInfo["address-street2"] ? addressInfo["address-street2"] : addressInfo["address2"],
                "address-street3": addressInfo["address-street3"] ? addressInfo["address-street3"] : addressInfo["address3"],
                "address-city": addressInfo["address-city"] ? addressInfo["address-city"] : addressInfo["city"],
                "address-state": addressInfo["address-state"] ? addressInfo["address-state"] : addressInfo["state"],
                "address-country": addressInfo.country ? addressInfo.country : null,
                "address-code": addressInfo["address-code"] ? addressInfo["address-code"] : addressInfo["zipcode"],
                action: "UPDATE",
            },
        },
        "ezshield-id": formData && formData["ezshield-id"],
    };

    return sendRequest("post", `api/secureMonitoring/manageMonitoredAssets`, requestBody);
};

const getMonitoringInfo = () => {
    const requestBody = {};
    return sendRequest("post", `api/secureMonitoring/getMonitoringAssetList`, requestBody);
};

const updateAddtionalInfo = async (personalData: any, additionalInfo: any, formData: any) => {
    const mmn =
        additionalInfo["motherMaidenName"] === "" && isObjectNotNull(formData.motherMaidenName)
            ? {
                  ...formData.motherMaidenName,
                  "is-monitored": true,
                  action: "DELETE",
              }
            : additionalInfo["motherMaidenName"] === formData["motherMaidenName"]["mother-maiden"]
            ? null
            : {
                  "monitor-id": "",
                  "record-id": "",
                  "is-monitored": true,
                  ...formData.motherMaidenName,
                  "mother-maiden": additionalInfo.motherMaidenName,
                  action: additionalInfo.motherMaidenName && formData["motherMaidenName"]["mother-maiden"] ? "UPDATE" : "ADD",
              };

    const DL =
        additionalInfo.driversLicence === ""
            ? {
                  ...formData.driversLicence,
                  "is-monitored": true,
                  action: "DELETE",
              }
            : additionalInfo.driversLicence === formData.driversLicence["driver-licence"]
            ? null
            : {
                  "monitor-id": "",
                  "record-id": "",
                  "is-monitored": true,
                  ...formData.driversLicence,
                  "driver-licence": additionalInfo.driversLicence,
                  action: additionalInfo.driversLicence && formData.driversLicence["driver-licence"] ? "UPDATE" : "ADD",
              };
    const pId = [formData.passportPrimary, ...formData.additionlPassports].filter((elem) => elem.passport);
    const newPassport: any = [];

    pId.forEach((elem) => {
        const { passport } = elem;
        if (!additionalInfo?.passports?.find((newPass: any) => newPass.passport === passport)) {
            newPassport.push({ ...elem, action: "DELETE" });
        }
    });

    additionalInfo?.passports?.forEach((elem: any) => {
        const { passport } = elem;
        if (!pId.find((newPass: any) => newPass.passport === passport)) {
            newPassport.push({ ...elem, action: "ADD" });
        }
    });

    const mIds = [formData.medicalInsurance, ...formData.additionalMedicalInsurance].filter((elem) => elem["medical-id"]);
    const newMedicalIds: any = [];

    mIds.forEach((elem) => {
        if (!additionalInfo?.medicalIds?.find((newMedicalId: any) => newMedicalId["medical-id"] === elem["medical-id"])) {
            newMedicalIds.push({ ...elem, "is-monitored": true, action: "DELETE" });
        }
    });

    additionalInfo?.medicalIds?.forEach((elem: any) => {
        if (!mIds.find((newMedicalId: any) => newMedicalId["medical-id"] === elem["medical-id"])) {
            newMedicalIds.push({ ...elem, "is-monitored": true, action: "ADD" });
        }
    });

    let additionalInfoPayload = {};
    if ([formData.medicalInsurance, ...formData.additionalMedicalInsurance].length > 0) {
        additionalInfoPayload = {
            "drivers-licence": DL,
            "mother-maiden-name": mmn,
            "additional-passports": newPassport.filter((element: any) => !!element),
            "additional-medicalids": newMedicalIds.filter((element: any) => !!element),
        };
    } else {
        const primaryPassport = newPassport !== undefined ? newPassport.splice(0, 1) : [{}];
        const primaryMedical = newMedicalIds !== undefined ? newMedicalIds.splice(0, 1) : [{}];
        additionalInfoPayload = {
            "drivers-licence": DL,
            "additional-passports": newPassport,
            "additional-medicalids": newMedicalIds,
            "mother-maiden-name": mmn,
            "medical-insurance": primaryMedical[0],
            "passport-primary": primaryPassport[0],
        };
    }

    const requestBody = {
        asset: {
            additionalInformation: additionalInfoPayload,
            personalInformation: personalData.personalInfo,
            addressInformation: personalData.addressInfo,
        },
        "ezshield-id": formData && formData["ezshield-id"],
    };
    if (!!mmn || !!DL || newPassport.filter((element: any) => !!element).length !== 0 || newMedicalIds.filter((element: any) => !!element).length !== 0) {
        return sendRequest("post", `api/secureMonitoring/manageMonitoredAssets`, requestBody);
    } else {
        return;
    }
};

export { updateMonitoringInfo, getMonitoringInfo, updateAddtionalInfo, updateBusinessMonitoringInfo, updateBusinessupdateAddtionalInfo };
